import axios from '../../../utils/axios';
import { apiurl } from '../../../config/apiUrl';

const sendPOQuery = (data) => {
    return axios.post(apiurl?.sendPO, data);
};
export default sendPOQuery;
